import { useNavigate } from "react-router-dom";

function Micro() {
  const navigate = useNavigate();
  return (
    <>
      {/* Header Start */}
      <div className="container-fluid bg-breadcrumb8">
        <div className="bg-breadcrumb-single" />
        <div className="container text-center py-5" style={{ maxWidth: 900 }}>
          <h4
            className="text-white display-4 mb-4 wow fadeInDown"
            data-wow-delay="0.1s"
          >
            Micro Services
          </h4>
        </div>
      </div>

      {/* Section 1 - Microservices Development (No background image) */}
      <section className="py-5 bg-white">
        <div className="container text-center wow fadeInUp" data-wow-delay="0.2s">
          <h2 className="display-5 mb-3">Microservices Development</h2>
          <p className="lead mx-auto" style={{ maxWidth: "850px", fontWeight:400 }}>
            Microservices architecture is transforming how applications are
            built, scaled, and managed. By breaking down complex applications
            into modular, independent services, we help organizations unlock new
            levels of agility, efficiency, and resilience.
          </p>
        </div>
      </section>

      {/* Section 2 - Why Celersoft Microservices */}
      <div className="container-fluid py-5 bg-light">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6 wow fadeInLeft" data-wow-delay="0.2s">
              <img
                src="assets/img/microserv1.png"
                alt="Microservices Concept"
                className="img-fluid rounded-4 shadow-lg"
              />
            </div>
            <div className="col-lg-6 wow fadeInRight" data-wow-delay="0.3s">
              <div
                className="p-4 rounded-4 shadow-sm"
                style={{
                  background: "rgba(255,255,255,0.9)",
                  backdropFilter: "blur(8px)",
                }}
              >
                <h3 className="fw-bold mb-3">Why Celersoft Microservices?</h3>
                <ul style={{ paddingLeft: "20px" }}>
                  <li>
                    <strong>Modular Scalability:</strong> Scale individual
                    services independently to handle growing demands without
                    impacting the whole application.
                  </li>
                  <li>
                    <strong>Faster Development Cycles:</strong> Deploy and
                    update specific features swiftly, keeping you ahead of
                    market needs.
                  </li>
                  <li>
                    <strong>Improved Reliability:</strong> Isolate services to
                    contain faults and ensure other components remain
                    operational.
                  </li>
                </ul>
                <p style={{ marginTop: -10 }}>
                  Our microservices solutions offer end-to-end support—from
                  strategy and design to deployment and management. We use
                  proven, cloud-native technologies to design resilient,
                  lightweight services that work independently but integrate
                  seamlessly for a cohesive user experience.{" "}
                  <button
                    onClick={() => navigate("/contact")}
                    className="btn btn-link text-primary fw-bold"
                  >
                    Contact Us
                  </button>{" "}
                  today.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Section 3 - Application Integration (Blue Background + Dummy Image) */}
      <section
        className="position-relative py-5 text-white"
        style={{
          background:
            "linear-gradient(135deg, rgba(5,15,45,0.95), rgba(0,65,112,0.95))",
        }}
      >
        <div className="container">
          <div className="row align-items-center g-5">
            {/* Left text section */}
            <div className="col-lg-6 wow fadeInLeft" data-wow-delay="0.2s">
              <h3 className="fw-bold mb-3 text-light">
                Application Integration
              </h3>
              <p className="text-light opacity-90">
                In today's digital landscape, seamless communication between
                applications is essential for businesses looking to boost
                efficiency and adaptability. Our Application Integration
                services ensure that your systems and applications work together
                without friction, providing a streamlined flow of data and
                improved productivity across your organization.
              </p>
            </div>

            {/* Right Image - Visible Dummy Image */}
            <div className="col-lg-6 wow fadeInRight text-center" data-wow-delay="0.3s">
              <img
               src="assets/img/microserv2.png"
                alt="Application Integration"
                className="img-fluid rounded-4 shadow-lg border border-light"
                style={{ maxHeight: "450px", objectFit: "cover" }}
              />
            </div>
          </div>
        </div>
      </section>

      {/* Section 4 - Key Benefits (Original Style) */}
      <section className="container-fluid py-5 bg-light">
        <div className="container">
          <h3 className="fw-bold mb-4 text-center">Key Benefits</h3>
          <div className="row g-4">
            <div className="col-md-4">
              <div className="p-4 bg-white shadow-sm rounded-4 h-100 text-center">
                <h5 className="text-primary">
                  <i className="fa fa-plug me-2" /> Enhanced Connectivity
                </h5>
                <p className="mb-0">
                  Connect diverse applications and platforms to improve cross-functional processes.
                </p>
              </div>
            </div>

            <div className="col-md-4">
              <div className="p-4 bg-white shadow-sm rounded-4 h-100 text-center">
                <h5 className="text-primary">
                  <i className="fa fa-sync-alt me-2" /> Real-Time Data Exchange
                </h5>
                <p className="mb-0">
                  Gain insights with synchronized data for timely, data-driven decisions.
                </p>
              </div>
            </div>

            <div className="col-md-4">
              <div className="p-4 bg-white shadow-sm rounded-4 h-100 text-center">
                <h5 className="text-primary">
                  <i className="fa fa-layer-group me-2" /> Scalable Solutions
                </h5>
                <p className="mb-0">
                  Build flexible integrations that evolve with your business and technology needs.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <div
        className="container-fluid py-5 text-white text-center wow fadeInUp"
        data-wow-delay="0.3s"
        style={{
          background: "linear-gradient(90deg, #004aad, #0077b6, #00b4d8)",
        }}
      >
        <div className="container py-4">
          <h2 className="fw-bold mb-3">
            
            Empower Your Systems with Modern Architecture
          </h2>
          <p className="lead mb-4">
            
         Our team utilizes industry-leading integration tools and platforms to create customized, robust solutions tailored to your requirements. From connecting legacy systems with modern applications to building unified APIs, we deliver integration solutions that enhance your system’s capabilities.
          </p>
          <p className="lead mb-4">
            
            Talk to our experts to explore how microservices and integration can
            transform your organization’s agility and efficiency.
          </p>

          <button
            onClick={() => navigate("/contact")}
            className="btn btn-light px-4 py-2 rounded-pill fw-semibold"
          >
            Get in Touch
          </button>
        </div>
      </div>

      {/* Footer Start */}
      <div className="container-fluid footer wow fadeIn" data-wow-delay="0.2s">
        <div className="container pt-4">
          <div className="row g-5">
            <div className="col-md-6 col-lg-6 col-xl-3">
              <p>
                <span style={{ fontSize: 20 }}>
                  <em>
                    <strong>USA</strong>
                  </em>
                </span>
              </p>
              <p>
                <i className="fas fa-map-marker me-1" />1500 S Dairy Ashford Rd
                <br />
                Ste 355 Houston
                <br />
                TX 77077
              </p>
            </div>

            <div className="col-md-6 col-lg-6 col-xl-3">
              <div className="single_address">
                <p>
                  <em>
                    <span style={{ fontSize: 20 }}>
                      <strong>CANADA</strong>
                    </span>
                  </em>
                </p>
                <p>
                  <i className="fas fa-map-marker me-1" /> 998 Loft Court,
                  <br />
                  London, Ontario
                  <br />
                  N6G0J9
                </p>
              </div>
            </div>

            <div className="col-md-6 col-lg-6 col-xl-3">
              <div className="single_address">
                <p>
                  <span style={{ fontSize: 20 }}>
                    <em>
                      <strong>INDIA</strong>
                    </em>
                  </span>
                </p>
                <p>
                  <i className="fas fa-map-marker me-1" /> D. No. 38, 2nd Floor,
                  <br />
                  Arjun Plaza, SP Road,
                  <br />
                  Nizampet, Hyderabad,
                  <br />
                  Telangana - 500085
                </p>
              </div>
            </div>

            <div className="col-md-6 col-lg-6 col-xl-3">
              <div className="footer-item d-flex flex-column">
                <a href="mailto:info@celersoft.com">
                  <i className="fas fa-envelope me-2" /> info@celersoft.com
                </a>
                <a href="tel:+18322258898">
                  <i className="fas fa-phone me-2" /> (+1) 832-225-8898
                </a>
                <hr />
                <div className="d-flex align-items-center">
                  <a
                    className="btn btn-light btn-md-square me-2"
                    href="https://www.facebook.com/celersoft"
                  >
                    <i className="fab fa-facebook-f" />
                  </a>
                  <a
                    className="btn btn-light btn-md-square me-0"
                    href="https://www.linkedin.com/company/celersoft/"
                  >
                    <i className="fab fa-linkedin-in" />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="container-fluid copyright py-3">
        <div className="container">
          <div className="row g-4 align-items-center">
            <div className="col-md-6 text-center text-md-start mb-md-0">
              <span className="text-body">
                <i className="fas fa-copyright text-light me-1" />
                2024 Celersoft. All rights reserved.
              </span>
            </div>
            <div className="col-md-6 text-center text-md-end text-body">
              {/* <a
                className="border-bottom text-primary"
                href="https://htmlcodex.com"
              >
                HTML Codex
              </a>{" "}
              Distributed By{" "}
              <a
                className="border-bottom text-primary"
                href="https://themewagon.com"
              >
                ThemeWagon
              </a> */}
            </div>
          </div>
        </div>
      </div>

      <button
        className="btn btn-primary btn-lg-square back-to-top"
        onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
      >
        <i className="fa fa-arrow-up" />
      </button>
      {/* Footer End */}
    </>
  );

  

      
}

export default Micro;
